// One height for every control in a list toolbar.
//
// Measured on staging, a single toolbar row held three different heights: the search
// box 56px (Input's own h-14 default), the Filters and Saved Filters triggers 41px
// (Button `md` padding — their height was never declared, it fell out of px-4
// py-[9px]) and rows-per-page 43px (MUI Select padding). The 48px the design spec
// asks for did exist, as FILTER_CONTROL, but that lives in the SalesDashboard folder
// and was only ever imported by the four dashboard filters.
//
// Deliberately NOT the same as a form field: Input keeps its 56px because form rows
// were verified uniform at that size, and filters are meant to read denser.

// For plain elements (inputs, buttons) that already carry a height class from a
// shared component and therefore need to win on specificity rather than order.
//
// This is the only export: a plain `h-12` and an MUI-slot variant were also defined
// here, but nothing imported either. The MUI one was a near-copy of FILTER_CONTROL,
// so keeping it would have left two spellings of the same override in the tree.
export const TOOLBAR_CONTROL_FORCE_H = '!h-12'
